import React, {Component} from "react";
import "./style.css";

interface IFearAndGreedValueProps {
    period: string;
    data: any;
};

class FearAndGreedValue extends Component<IFearAndGreedValueProps, {}> {

    public colors = {
        'extreme fear': '#bf1e2d',
        'fear': '#f0592a',
        'neutral': '#a3a3a3',
        'greed': '#86c240',
        'extreme greed': '#35a046'
    };

    public render() {
        const data = this.props.data;
        const color = this.colors[data.valueText.toLowerCase()] || '#716565';

        return <div className="ValueContainer">
            <div className="ValueContainerLeft">
                <div className="ValueContainerPeriod">{this.props.period}</div>
                <div className="ValueContainerText" style={{ color }}>{data.valueText}</div>
            </div>
            <div className="ValueContainerCircle" style={{ backgroundColor: color }}>{data.value}</div>
        </div>;
    }
}

export default FearAndGreedValue;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/FearAndGreedIndex/FearAndGreedValue.tsx